import { Grid, ListItem } from '@mui/material';
import { IMaterial } from '../../interfaces';
import { MaterialDetailsDialog } from '../MaterialDetailsDialog';

export const StoredAssemblyComponent: React.FC<{ material: IMaterial }> = ({ material }) => {
    return (
        <ListItem key={material.materialId}>
            <Grid container>
                <Grid item flex={"auto"}>
                    <strong>{material.serialNumber ? material.serialNumber : "-"}</strong>
                </Grid>
                <Grid item>
                    <MaterialDetailsDialog material={material} viewMode="search_result" />
                </Grid>
            </Grid>
        </ListItem>
    );
}
